export default __webpack_public_path__ + "static/media/activity-points-tracker.8c9eef0d.png";